export default {"src":"/_next/static/media/planning-and-scoping.19d5bf67.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};